// TODO: separate GA4 utils with PMT-Tracking utils

// GA4-style ID generation utilities
export const generateId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 11);
};

export const generateGA4StyleSessionId = (timestamp: number): string => {
  // GA4 uses timestamp + random component for session IDs
  return `${Math.floor(timestamp / 1000)}.${Math.random().toString(36).slice(2, 11)}`;
};

export const generateGA4StyleClientId = (): string => {
  // Generate GA4-style client ID: timestamp + random
  return `${Date.now()}.${Math.random().toString().slice(2, 11)}`;
};

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: GTM dataLayer is untyped by Google
    dataLayer: any;
    // biome-ignore lint/suspicious/noExplicitAny: GTM tag manager is untyped by Google
    google_tag_manager: any;
  }
}

// TODO: delete this function or the 1st line inside pushEvent() function
export const resetGTMDataLayer = (): void => {
  // window.google_tag_manager[publicRuntimeConfig.GTM_ID]?.dataLayer?.reset()
  // .reset() is dangerous since it's deleting the whole dataLayer, including the gtm.start event, and others
  window.dataLayer = window.dataLayer || [];
};

// biome-ignore lint/suspicious/noExplicitAny: GTM event details are untyped
export const pushEvent = (eventName: string, details?: Record<string, any>): void => {
  window.dataLayer = window.dataLayer || []; // for event not using resetGTMDataLayer()

  if (window.google_tag_manager) {
    // Google Tag Manager has already been loaded
    window.dataLayer.push({
      event: eventName,
      ...details,
    });
  } else {
    window.addEventListener('gtm_loaded', () => {
      // Google Tag Manager has been loaded
      window.dataLayer.push({
        event: eventName,
        ...details,
      });
    });
  }
};

export const resetDataLayerAndPushEvent: typeof pushEvent = (eventName, details = undefined): void => {
  resetGTMDataLayer();
  pushEvent(eventName, details);
};

// PMT
const chipModify = (chip: string) => {
  if (!chip.length) {
    return chip;
  }
  const invalidChar = /[^-a-zA-Z0-9_.]+/g;
  const modifiedText = chip.replace(invalidChar, '');
  return modifiedText.substring(0, 50).toUpperCase();
};

export const trackingInputModify = (text: string): string[] | undefined => {
  const chips = text.split(/[,:; ]+/);

  if (chips.length === 1) {
    return;
  }

  return chips.map((chip: string) => chipModify(chip)).filter((chip: string) => !!chip);
};

export const trackingInputPasteModify = (text: string): string[] | undefined => {
  const chips = text
    .split(/[,:; ]+/)
    .map((chip: string) => chipModify(chip))
    .filter((chip: string) => !!chip);

  if (!chips.length) {
    return;
  }

  return chips;
};

const MAX_CHIP = 5;
const PARAM_SEPARATOR = '~';

export const trackingParamExtractionModify = (parcelIdsStr: string): string[] => {
  const parcelIds = parcelIdsStr
    .split(PARAM_SEPARATOR)
    .map((parcelId) => chipModify(parcelId))
    .filter((parcelId) => !!parcelId);

  return Array.from(new Set(parcelIds)).slice(0, MAX_CHIP);
};
